var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "schedule-upload",
        "content-css": { minWidth: "30vw" },
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true
      },
      model: {
        value: _vm.scheduleUploadOpen,
        callback: function($$v) {
          _vm.scheduleUploadOpen = $$v
        },
        expression: "scheduleUploadOpen"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-icon", { attrs: { name: "playlist add check" } }),
              _c("q-toolbar-title", [
                _vm._v("\n        Schedule Uploads\n      ")
              ]),
              _c("q-icon", {
                attrs: { name: "clear", disabled: _vm.processingSchedule },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              })
            ],
            1
          ),
          !_vm.scheduleProcessed
            ? _c(
                "div",
                { staticClass: "layout-padding", attrs: { id: "upload-body" } },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v("You can upload your class schedules using this "),
                      _c("i", {
                        staticClass: "fa fa-file-excel-o",
                        staticStyle: {
                          "font-size": "28px",
                          "vertical-align": "middle"
                        }
                      }),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "statics\\examples\\Schedule- format.xlsx",
                            target: "_blank"
                          }
                        },
                        [_vm._v("format")]
                      ),
                      _vm._v("."),
                      _c("br"),
                      _vm._v(
                        " You must provide the instructor code for a valid import."
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "q-pt-xl q-px-sm" },
                    [
                      _c("h6", [_vm._v(" Select File.. ")]),
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-sm",
                          attrs: {
                            helper:
                              "Accepts Microsoft Excel Documents (.xlsx, .xls)"
                          }
                        },
                        [
                          _c("q-uploader", {
                            ref: "scheduleUpload",
                            attrs: {
                              "auto-expand": "",
                              "hide-upload-button": "",
                              url: "",
                              "url-factory": _vm.uploadFile,
                              extensions: ".xlsx,.xls"
                            },
                            on: { finish: _vm.onFinish }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.scheduleProcessed
            ? _c(
                "div",
                {},
                [
                  _vm.processedRows.length > 0
                    ? _c("Grid", {
                        attrs: {
                          selectable: "multiple",
                          columns: _vm.columnOptions,
                          data: _vm.processedRows,
                          visibleColumns: _vm.visibleColumns,
                          hideShowColumns: true,
                          exceptionMap: _vm.scheduleUploadExceptionMap,
                          selected: _vm.selectedScheduleProcessRows,
                          pagination: _vm.paginationOptions,
                          onSelect: _vm.updateSelectedProcessedRows,
                          "hide-footer": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "col-item-affiliate",
                            fn: function(props) {
                              return [
                                _vm.processedRows[props.index].AFFILIATE
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.processedRows[props.index]
                                              .AFFILIATE.AFFILIATE_NAME
                                          ) +
                                          " - (" +
                                          _vm._s(
                                            _vm.processedRows[props.index]
                                              .AFFILIATE.AFFILIATE_CODE
                                          ) +
                                          ")\n          "
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.processedRows[props.index].AFFILIATE
                                  ? _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "\n            Not Valid Affiliate\n            "
                                        ),
                                        _c(
                                          "q-icon",
                                          {
                                            staticStyle: {
                                              "vertical-align": "middle"
                                            },
                                            attrs: {
                                              name: "help",
                                              color: "red",
                                              size: "17px"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                staticClass: "red",
                                                attrs: {
                                                  anchor: "top middle",
                                                  self: "bottom middle",
                                                  offset: [10, 10]
                                                }
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px"
                                                    }
                                                  },
                                                  [_vm._v("Possible Reasons")]
                                                ),
                                                _vm._v(
                                                  "\n                        Affiliate may be inactive."
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                        Affiliate code was empty."
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                        You may not have access to the Affiliate.\n              "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "col-item-date",
                            fn: function(props) {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.moment
                                        .utc(props.value)
                                        .format("MMMM Do, YYYY")
                                    ) +
                                    "\n          "
                                ),
                                _vm.processedRows[props.index].BAD_START_DATE
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "q-icon",
                                          {
                                            staticStyle: {
                                              "vertical-align": "middle"
                                            },
                                            attrs: {
                                              name: "help",
                                              color: "red",
                                              size: "17px"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                staticClass: "red",
                                                attrs: {
                                                  anchor: "top middle",
                                                  self: "bottom middle",
                                                  offset: [10, 10]
                                                }
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Date must be at least 30 days out"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "col-item-instructor",
                            fn: function(props) {
                              return [
                                _vm.processedRows[props.index].INSTRUCTOR
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.processedRows[props.index]
                                              .INSTRUCTOR.USER.USER_FIRST_NAME +
                                              " " +
                                              _vm.processedRows[props.index]
                                                .INSTRUCTOR.USER.USER_LAST_NAME
                                          ) +
                                          "\n          "
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.processedRows[props.index].INSTRUCTOR
                                  ? _c(
                                      "span",
                                      [
                                        _vm._v(
                                          "\n            Not Valid Instructor\n            "
                                        ),
                                        _c(
                                          "q-icon",
                                          {
                                            staticStyle: {
                                              "vertical-align": "middle"
                                            },
                                            attrs: {
                                              name: "help",
                                              color: "red",
                                              size: "17px"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                staticClass: "red",
                                                attrs: {
                                                  anchor: "top middle",
                                                  self: "bottom middle",
                                                  offset: [10, 10]
                                                }
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px"
                                                    }
                                                  },
                                                  [_vm._v("Possible Reasons")]
                                                ),
                                                _vm._v(
                                                  "\n                        Instructor may not belong to Affiliate."
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                        Instructor may be inactive."
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                        Instructor may not be approved."
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                        Instructor code was empty.\n              "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm.processedRows.length == 0
                    ? _c(
                        "div",
                        { staticClass: "q-pa-xl text-center" },
                        [
                          _c("q-icon", {
                            attrs: {
                              name: "search",
                              color: "grey-5",
                              size: "60px"
                            }
                          }),
                          _c("br"),
                          _vm._v("\n        No records to import\n      ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.scheduleProcessed
                ? _c("q-btn", {
                    attrs: {
                      outline: "",
                      color: "faded",
                      disabled: _vm.processingSchedule,
                      label: "Reset",
                      icon: "refresh"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.resetScheduleUpload($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n      "),
              _vm.selectedScheduleProcessRows.length > 0 &&
              _vm.scheduleProcessed &&
              !_vm.processingSchedule
                ? _c("q-btn", {
                    attrs: {
                      outline: "",
                      color: "red",
                      label: "Remove Selected"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.removeSelectedProcessedRows($event)
                      }
                    }
                  })
                : _vm._e(),
              _c("q-toolbar-title"),
              _vm.scheduleProcessed && !_vm.validRows
                ? _c(
                    "span",
                    {
                      staticClass: "text-red",
                      staticStyle: {
                        "margin-right": "3px",
                        "vertical-align": "middle",
                        "font-size": "13px"
                      }
                    },
                    [
                      _c("q-icon", {
                        attrs: { name: "error", color: "red", size: "20px" }
                      }),
                      _vm._v(" Please remove invalid rows!\n      ")
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.scheduleProcessed
                ? _c("q-btn", {
                    attrs: {
                      label: "Upload",
                      color: "green",
                      disabled: _vm.processingSchedule
                    },
                    on: {
                      click: function($event) {
                        _vm.upload()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n      "),
              _vm.scheduleProcessed
                ? _c("q-btn", {
                    attrs: {
                      label: "Finalize",
                      color: "green",
                      disabled:
                        !_vm.validRows ||
                        _vm.processedRows.length == 0 ||
                        _vm.processingSchedule,
                      icon: "cloud_upload"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.finalizeUploadMethod($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: {
                  outline: "",
                  color: "faded",
                  disabled: _vm.processingSchedule,
                  label: "Cancel"
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.processingSchedule } },
        [
          _c("q-spinner-gears", { attrs: { color: "primary", size: "70" } }),
          _c("span", [_vm._v("Processing")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }